/**
 * 生成单据编号
 */
export default class NewKeyUtil {

  /**
   * 生成唯一ID,guid方式
   * @returns {string}
   */
  static newGuid () {
    let guid = '{' + S4() + S4() + '-' + S4() + '-' + S4() + '-' + S4() + '-' + S4() + S4() + S4() + '}'
    return guid.toUpperCase()
  }

}

function S4 () {
  return (((1 + Math.random()) * 0x10000) | 0).toString(16).substring(1)
}


// WEBPACK FOOTER //
// ./src/wbap-utils/NewKeyUtil/index.js